/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function ChevronRightIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "chevron-right", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M10 8L15.5 12.5L10 17", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(ChevronRightIcon);
export default ForwardRef;
//# sourceMappingURL=chevronRightIcon.js.map